import { BaseCaller } from "./api";
import { DriverStateDTO } from "./model";

export default class DriverApi {
  private caller: BaseCaller;

  constructor(caller: BaseCaller) {
    this.caller = caller;
  }

  public list(): Promise<any> {
    return this.caller.get("driver/");
  }

  public listAvailable(): Promise<any> {
    return this.caller.get("driver/getAvailable");
  }

  public listActiveByAdmin(): Promise<any> {
    return this.caller.get("driver/active/byAdmin");
  }

  save(data: any) {
    if (data.driver.id) {
      return this.caller.put(`driver/${data.driver.id}`, data);
    }
    return this.caller.post("driver/", data);
  }

  public filter(search: string) {
    const squery =
      search.trim().toUpperCase().length > 0
        ? `?search=${search.trim().toUpperCase()}`
        : "";
    return this.caller.get(`driver/filter${squery}`);
  }

  disable(id: string) {
    return this.caller.post(`driver/${id}/inactivate`, {});
  }

  activate(id: string) {
    return this.caller.post(`driver/${id}/activate`, {});
  }

  location(id: number): Promise<DriverStateDTO> {
    return this.caller.get(`driver/${id}/location`);
  }

  locations(): Promise<DriverStateDTO[]> {
    return this.caller.get(`driver/locations`);
  }
}



// WEBPACK FOOTER //
// ./src/api/driver-api.ts